// Single source of truth for pricing across the entire site (landing, modal, billing, info pages).
export const SUPPORT_EMAIL = "support@klyrstudio.io";
export const CONTACT_EMAIL = "hello@klyrstudio.io";
export const CAREERS_EMAIL = "careers@klyrstudio.io";

// Canonical prices (USD). Book prices live in BOOK_TIERS below.
export const PRICE = {
  series_unlock: 19,
};

// Volume pricing (must match backend payments.py BOOK_TIERS): the order quantity sets one price for every book.
export const BASE_BOOK_PRICE = 45;
export const MAX_BOOKS = 50;
export const BOOK_TIERS = [
  { min: 1, unit_price: 45 }, { min: 3, unit_price: 40 }, { min: 6, unit_price: 39 }, { min: 9, unit_price: 38 },
  { min: 12, unit_price: 37 }, { min: 15, unit_price: 36 }, { min: 18, unit_price: 35 },
];
export const bookQuote = (qty) => {
  const unit = [...BOOK_TIERS].reverse().find((t) => qty >= t.min).unit_price;
  return { quantity: qty, unit_price: unit, total: unit * qty, savings: (BASE_BOOK_PRICE - unit) * qty };
};
export const PACKAGE_INCLUDES = [
  "Complete book generation", "Cover creation in Cover Studio", "Book editor access",
  "Print-ready KDP interior PDF", "Print-ready KDP cover PDF", "Complete downloadable ZIP package",
  "README + step-by-step publishing instructions", "Editable manuscript files (DOCX, EPUB)",
  "Re-download your files any time",
];

// Public pricing tiers shown on the landing page.
export const PRICING_TIERS = [
  {
    key: "free",
    name: "Free previews",
    price: "$0",
    unit: "",
    featured: false,
    points: ["3 free book previews", "Cover + contents + first page", "Try all writing & puzzle modes", "Unlock the full book anytime"],
    cta: "Start free",
  },
  {
    key: "credits",
    name: "Complete book",
    price: `$${BASE_BOOK_PRICE}`,
    unit: "/ book",
    featured: true,
    note: "3+ books $40 each · down to $35 each at 18+",
    points: ["Full book + cover + editor", "Amazon KDP interior & cover PDFs", "ZIP package with README", "Credits never expire"],
    cta: "Buy book credits",
  },
  {
    key: "series",
    name: "Series Mode",
    price: `$${PRICE.series_unlock}`,
    unit: "/ series",
    featured: false,
    points: ["Shared character bible", "Consistent world & settings", "Link unlimited books", "Perfect for kids' series"],
    cta: "Start a series",
  },
];
